export const ALERT = {
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  ERROR: "ERROR",
  CLEAR: "CLEAR",
};
